import { CircleCheck } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgCheckCircle1 = mkIcon(CircleCheck);